<template>
  <div class="app-footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <h3>解决方案</h3>
          <ul>
            <li><router-link to="/solutions">工业物联网</router-link></li>
            <li><router-link to="/solutions">智慧城市</router-link></li>
            <li><router-link to="/solutions">智慧农业</router-link></li>
            <li><router-link to="/products">eSIM</router-link></li>
            <li><router-link to="/products">vSIM</router-link></li>
          </ul>
        </div>
        <div class="footer-section">
          <h3>关于我们</h3>
          <ul>
            <li><router-link to="/about">公司简介</router-link></li>
            <li><router-link to="/news">新闻动态</router-link></li>
            <li><router-link to="/contact">合作</router-link></li>
          </ul>
        </div>
        <div class="footer-section">
          <h3>联系我们</h3>
          <!-- <p><i class="el-icon-phone"></i> 400-188-0608</p>
          <p><i class="el-icon-message"></i> 611699108@qq.com</p>
          <p><i class="el-icon-location"></i> 深圳南山区深南大道10128号南山数字文化产业基地西塔1103</p> -->
          <p>业务合作: 400-188-0608</p>
          <p>售后服务: 0755-83224006</p>
          <p>邮箱: 611699108@qq.com</p>
          <p>地址: 深圳南山区深南大道10128号南山数字文化产业基地西塔1103</p>
        </div>
        
        <div class="footer-section qrcode">
          <h3>关注我们</h3>
          <img src="@/assets/images/footer/qrcode.png" alt="微信公众号">
          <!-- <p>扫码关注公众号</p> -->
        </div>
      </div>
      <div class="footer-site">
        <h2>专业的物联网无线通讯接入服务商</h2>
        <h2>Professional IoT  wireless communication access service provider</h2>
      </div>
      <div class="footer-bottom">
        <p>粤ICP备20053887号</p>
        <p>&copy; 2020 深圳市桔子智联信息技术有限公司 版权所有</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style lang="scss" scoped>
.app-footer {
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }
  
  .footer-content {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
    margin-bottom: 40px;
  }
  
  .footer-section {
    h3 {
      color: #fff;
      font-size: 18px;
      margin-bottom: 20px;
    }
    
    p {
      color: #a8b2c1;
      margin-bottom: 10px;
      
      i {
        margin-right: 8px;
      }
    }
    
    ul {
      list-style: none;
      padding: 0;
      
      li {
        margin-bottom: 10px;
        
        a {
          color: #a8b2c1;
          text-decoration: none;
          transition: color 0.3s;
          
          &:hover {
            color: #fff;
          }
        }
      }
    }
    
    &.qrcode {
      text-align: center;
      
      img {
        width: 120px;
        height: 120px;
        margin-bottom: 10px;
      }
    }
  }

  .footer-site{
    border-top: 1px solid rgba(255,255,255,0.1);
    color:#409EFF
  }
  
  .footer-bottom {
    border-top: 1px solid rgba(255,255,255,0.1);
    padding-top: 20px;
    text-align: center;
    
    p {
      color: #a8b2c1;
      font-size: 14px;
    }
  }
}

@media screen and (max-width: 768px) {
  .app-footer {
    .container {
      padding: 0 15px;
    }
    
    .footer-content {
      grid-template-columns: 1fr;
      gap: 20px;
    }
    
    .footer-section {
      text-align: center;
      
      &.qrcode {
        img {
          width: 100px;
          height: 100px;
        }
      }
    }
  }
}
</style> 